<!--  -->
<template>
  <div>
    <div class="left">
      <parkover />
      <equipment />
    </div>
    <div class="bottom">
      <crudeoil />
      <personnel />
      <detection />
      <monitor />
    </div>
  </div>
</template>

<script>
import parkover from "../components/overview/parkover";
import equipment from "../components/overview/equipment";
import crudeoil from "../components/overview/crudeoil";
import personnel from "../components/overview/personnel";
import detection from "../components/overview/detection";
import monitor from "../components/overview/monitor"
export default {
  data() {
    return {};
  },

  components: {
    parkover,
    equipment,
    crudeoil,
    personnel,
    detection,
    monitor
  },

  computed: {},

  methods: {}
};
</script>
<style lang="less" scoped>
.left {
  position: absolute;
  top: 10%;
  left: 2.5%;
  width: 15%;
  // background: red;
}
.bottom {
  position: absolute;
  bottom: 5vh;
  left: 2.5%;
  display: flex;
}
</style>